<template>
  <div class="navbar">
    <div :class="containerClasses">
      <b-navbar>
        <template slot="brand">
          <b-navbar-item href="/">
            <img
              src="@/assets/img/logo.png"
              alt="Psyservice"
            >
          </b-navbar-item>
        </template>
        <template slot="start">
          <router-link to="/#busca-profissionais">
            <b-navbar-item class="nav-menu-item">
              Busca de Profissionais
            </b-navbar-item>
          </router-link>
          <router-link to="/blog">
            <b-navbar-item class="nav-menu-item">
              Blog
            </b-navbar-item>
          </router-link>
          <router-link to="/sobre">
            <b-navbar-item class="nav-menu-item">
              Sobre
            </b-navbar-item>
          </router-link>
          <a @click="isContinuingEducationModalOpen = true">
            <b-navbar-item class="nav-menu-item">
              Formação Continuada
            </b-navbar-item>
          </a>
          <a v-if="currentUser" @click="isClinicalSupervisionFormOpen = true">
            <b-navbar-item class="nav-menu-item">
              Supervisão Clínica
            </b-navbar-item>
          </a>
          <a @click="isContactFormModalOpen = true">
            <b-navbar-item class="nav-menu-item">
              Fale Conosco
            </b-navbar-item>
          </a>
        </template>

        <template slot="end">
          <b-navbar-item tag="div">
            <div class="buttons">
              <div v-if="currentUser">
                <button
                  class="button is-primary"
                  @click="logout"
                >
                  Sair
                </button>
                <router-link
                  to="/dashboard"
                  class="button is-light"
                >
                  Painel
                </router-link>
              </div>
              <div v-else>
                <router-link
                  to="/login"
                  class="button is-primary"
                >
                  Login
                </router-link>
                <router-link
                  to="/login"
                  class="button is-light"
                >
                  Cadastre-se
                </router-link>
              </div>
            </div>
          </b-navbar-item>
        </template>
      </b-navbar>
    </div>

    <b-modal
      :active.sync="isContactFormModalOpen"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-modal
    >
      <ContactForm></ContactForm>
    </b-modal>
    <b-modal
      :active.sync="isClinicalSupervisionFormOpen"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-modal
    >
      <ClinicalSupervisionForm></ClinicalSupervisionForm>
    </b-modal>
    <b-modal
      :active.sync="isContinuingEducationModalOpen"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-modal
    >
      <ContinuingEducationModal></ContinuingEducationModal>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ContactForm from './ContactForm'
import ClinicalSupervisionForm from './ClinicalSupervisionForm'
import ContinuingEducationModal from './ContinuingEducationModal'

const fb = require('@/firebaseConfig.js')

export default {
  components: {
    ContactForm,
    ClinicalSupervisionForm,
    ContinuingEducationModal
  },
  data () {
    return {
      isContactFormModalOpen: false,
      isClinicalSupervisionFormOpen: false,
      isContinuingEducationModalOpen: false,
      isDashboard: false
    }
  },
  computed: {
    ...mapState(['currentUser']),
    containerClasses: function () {
      return this.isDashboard ? 'container dashboard' : 'container'
    }
  },
  methods: {
    logout () {
      fb.auth.signOut().then(async () => {
        await this.$store.dispatch('clearData')
        this.$router.push('/login')
      }).catch(err => {
        console.log(err)
      })
    }
  },
  mounted () {
    this.isDashboard = this.$route.path === '/dashboard'
  },
  watch: {
    '$route' () {
      this.isDashboard = this.$route.path === '/dashboard'
    }
  }
}
</script>
<style>
.modal section {
  margin: unset !important;
}
.modal.is-active {
  z-index: 10000;
}
</style>
